import React from "react";
//import HeaderBottomArea from "./header-bottom-area";
import HeaderMiddleArea from "./header-middle-area";
import HeaderTopArea from "./header-top-area";

function Header(): React.JSX.Element {
  return (
    <header>
      <HeaderMiddleArea />
      <HeaderTopArea />
      {/*<HeaderBottomArea />*/}
    </header>
  );
}

export default Header;
